export default "__VITE_ASSET__CbU_lZkb__"